<template>
    <div class="vh-100 vw-100 d-flex flex-column">
      <DefaultHeader :noMargin="true"/>
      <MissionHistoryMap />
    </div>
  </template>
  
  <script>
  import DefaultHeader from '@/components/DefaultHeader.vue'
  import MissionHistoryMap from './Sections/MissionHistoryMap.vue'
  
  export default {
      components: {
          DefaultHeader,
          MissionHistoryMap
      },
      computed: {
          currentUser() {
              return this.$store.state.auth.user
          }
      },
      mounted() {
          if (!this.currentUser) {
              this.$router.push('/')
          }
      }
  }
  </script>